import React from "react";
import "./SpotBanner.css";

import leaf1 from "../../Images/leaf1.png";

const SpotBanner = ({ selectedCity }) => {
  return (
    <section className="spot-banner">
      <div className="spot-banner-content">
        <h1 className="spot-banner-title">
          <span className="spot-highlight">Only 3</span> Spots Left This <br />
          Month!
        </h1>

        <p className="spot-banner-desc">
          Your competitors are already closing deals using real-time owner
          property data. Get access to {selectedCity}'s verified owner database
          before you lose more opportunities.
        </p>

        <div className="spot-form-wrapper">
          <img src={leaf1} alt="" className="spot-dots spot-dots-left" />
          <img src={leaf1} alt="" className="spot-dots spot-dots-right" />

          <div className="spot-banner-form">
            <input
              type="email"
              placeholder="Email Address"
              className="spot-input"
            />

            <button className="spot-btn">Register →</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpotBanner;
